// Minimal JWT decode (no signature verification)
// Returns { header, payload, signature, raw } or throws on invalid format

function base64UrlDecode(str) {
  const b64 = str.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(str.length / 4) * 4, '=');
  const binary = typeof atob !== 'undefined' ? atob(b64) : Buffer.from(b64, 'base64').toString('binary');
  let result = '';
  for (let i = 0; i < binary.length; i++) result += String.fromCharCode(binary.charCodeAt(i));
  try {
    return decodeURIComponent(escape(result));
  } catch (_) {
    return result;
  }
}

export function decodeJwt(token) {
  if (!token || typeof token !== 'string') throw new Error('Invalid JWT');
  const parts = token.split('.');
  if (parts.length !== 3) throw new Error('Invalid JWT format');
  const [headerB64, payloadB64, signatureB64] = parts;
  const header = JSON.parse(base64UrlDecode(headerB64));
  const payload = JSON.parse(base64UrlDecode(payloadB64));
  return { header, payload, signature: signatureB64, raw: token };
}
